import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';
import { LEAD_TRUMP_POST_ALERT } from '../../shared/constants/strings';
import { MetadataService } from '../../shared/services/metadata.service';
import { TitleService } from '../../shared/services/title.service';

@Component({
  selector: 'app-trump-post-alert',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule],
  templateUrl: './trump-post-alert.component.html',
  styleUrls: ['./trump-post-alert.component.scss'],
})
export class TrumpPostAlertComponent implements OnInit {
  imgPath = environment.storageImgPath;
  trumpImageWidths = [1681, 1500, 1200, 750, 500, 350];
  trumpFallbackImage = this.imgPath + '/start/trump-post-alert-w1200.webp';
  titleImage = this.trumpFallbackImage;

  constructor(
    private metadataService: MetadataService,
    private titleService: TitleService,
  ) {}

  public get LEAD_TRUMP_POST_ALERT() {
    return LEAD_TRUMP_POST_ALERT;
  }

  ngOnInit(): void {
    this.titleService.setTitle('Trump Post Alert');
    this.metadataService.updateTags(
      'Trump Post Alert',
      'TrumpPostAlert.com sendet in Sekundenbruchteilen Analysen zu Donald Trumps Truth-Social-Posts und bewertet die Marktrelevanz für Anleger.',
      'Trump Post Alert, TrumpPostAlert, Marktreaktion, Truth Social Monitoring, KI Auswertung',
      [this.titleImage],
    );
  }
}
